import { ButtonHTMLAttributes, forwardRef } from 'react';
import { ButtonVariants } from './buttonTypes';
import Icon from '#sign-up/components/Icons/Icon';
import { IconSize } from '#sign-up/components/Icons/iconTypes';
import { cx } from '#/Scripts/utilities/cx';

interface IconButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  iconName: string;
  title: string;
  iconSize?: IconSize;
  variant?: ButtonVariants;
}

export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  ({ iconName, title, iconSize = IconSize.small, variant = ButtonVariants.plain, className = '', ...props }, ref) => {
    return (
      <button
        className={cx('button', variant, className)}
        aria-label={title}
        title={title}
        type="button"
        ref={ref}
        {...props}
      >
        <Icon size={iconSize} className="material-icons-outlined">
          {iconName}
        </Icon>
      </button>
    );
  }
);

IconButton.displayName = 'IconButton';
